import { useContext } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames';

import { ConfigContext } from '@providers/ConfigProvider';
import LargeHeading from '@components/atoms/LargeHeading';
import { FormattedMessage } from 'utils/intl';

import messages from './BadgeSection.messages';
import classes from './BadgesSection.module.scss';

const BadgeSectionCommon = dynamic(() => import('./BadgeSectionCommon'), { ssr: true });
const BadgeSectionDellowo = dynamic(() => import('./BadgeSectionDellowo'), { ssr: true });
const BadgeSectionPremiumStation = dynamic(() => import('./BadgeSectionPremiumStation'), { ssr: true });

type Props = {
  className?: string;
};

const BadgesSection = ({ className }: Props): JSX.Element => {
  const { isBiznesowe, isDellowo, isPremiumStation, isPremiumSerwer, isCocon, isFirewall } = useContext(ConfigContext);

  return !isFirewall ? (
    <div className={classNames(className, classes.wrapper)}>
      <LargeHeading
        title={<FormattedMessage {...messages.title} />}
        subtitle={<FormattedMessage {...messages.subtitle} />}
      />
      {(isBiznesowe || isCocon || isPremiumSerwer) && <BadgeSectionCommon />}
      {isDellowo && <BadgeSectionDellowo />}
      {isPremiumStation && <BadgeSectionPremiumStation />}
    </div>
  ) : (
    <></>
  );
};

export default BadgesSection;
